import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

type IconProps = {
  size?: number;
  color?: string;
};

const GameControlIcon: React.FC<IconProps> = ({ size = 47, color }) => {
  return (
    <Svg
      width={size}
      height={size * (30 / 47)}
      viewBox="0 0 47 30"
      fill="none"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.931 27.106c1.546-1.543 3.374-3.108 4.732-5.135h19.671c1.362 2.023 3.19 3.592 4.731 5.135C49.903 38.938 49.108 11.22 40.743 2.894H40.1C39.048 1.167 36.994 0 34.634 0c-2.36 0-4.41 1.167-5.462 2.894H17.828C16.776 1.167 14.722 0 12.362 0c-2.36 0-4.41 1.167-5.466 2.894h-.642c-8.365 8.326-9.16 36.04 2.677 24.212zM11.418 4.82h4.249v3.322h3.385v4.17h-3.385v3.322h-4.25v-3.322H8.033v-4.17h3.386V4.82zm20.39 9.031c1.029 0 1.863.819 1.863 1.828 0 1.01-.834 1.832-1.863 1.832s-1.863-.818-1.863-1.832c0-1.01.834-1.828 1.863-1.828zm1.017-8.142c1.492 0 2.7 1.187 2.7 2.647 0 1.464-1.208 2.646-2.7 2.646-1.491 0-2.696-1.186-2.696-2.646s1.205-2.647 2.696-2.647zm6.97 4.092c1.028 0 1.862.818 1.862 1.828 0 1.01-.834 1.828-1.863 1.828s-1.866-.818-1.866-1.828c0-1.01.837-1.828 1.866-1.828z"
        fill={color || 'url(#paint0_linear_4535_11807)'}
      />
      {!color && (
        <Defs>
          <LinearGradient
            id="paint0_linear_4535_11807"
            x1={3.73269}
            y1={4.14609}
            x2={39.5309}
            y2={27.8494}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#EE3823" />
            <Stop offset={1} stopColor="#FCAF41" />
          </LinearGradient>
        </Defs>
      )}
    </Svg>
  );
};

export default GameControlIcon;
